module.exports = __webpack_public_path__ + "static/media/400124_02.18d33f24.png";